<div style="margin: 10px 20px 20px;">
  <div *ngIf="!isAnalyzing && verdictAvailable">

    <div class="m-progContainer">
      <div class="d-flex justify-content-between legend">
        <p>{{ 'overview.0_less_risk' | translate }}</p>
        <p>{{ 'overview.more_risk_100' | translate }}</p>
      </div>

      <div class="d-flex align-items-center">
        <div class="m-progbar"></div>
        <div id="myBBar" class="w3-black tic" [ngStyle]="{'right': barPosition }"></div>
      </div>

      <div class="mt-2 w3-bar-val d-flex align-items-center flex-wrap gap-2" style="justify-content: space-around;">
        <div class="d-flex align-items-center">
          <span [style.font-size]="'13px'">
            {{ 'overview.risk' | translate }}:
            <span [ngClass]="getRiskLevelColor()">{{ riskLevelLabel }}</span>
          </span>
          <i class="ms-2 ms-Icon ms-Icon--InfoSolid" style="cursor: pointer; font-size: 13px" (click)="showScoreInfo()"></i>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!isAnalyzing && adminEmail" class="mt-2 d-flex justify-content-end">
    <span class="overview-link ms-2" (click)="handleReportPhishingWithConfirm()" style="color: #0A4D90; font-size: 13px"
          [matTooltip]="getReportAsPhishingTooltip()">
      {{ 'overview.report_as_phishing' | translate }}
    </span>
  </div>

  <div *ngIf="isAnalyzing">
    <div>
      <mat-progress-bar class="custom-progress" mode="indeterminate"></mat-progress-bar>
    </div>
  </div>

  <ng-container *ngFor="let section of riskService.getOverviewMap() | keyvalue: asIsOrder">
    <div class="box-container mt-4" *ngIf="section.value.overviewTextSet.size > 0">
      <div class="box-header">
        <span>{{ section.key }}</span>
      </div>
      <div *ngFor="let item of section.value.overviewTextSet; let i = index" class="box-item">
        <ng-container *ngIf="i < getSectionLimit(section.key)">
          <span [ngStyle]="{'color': getSectionDTO(section.key).icon_color ?? 'black'}" class="me-2">
            <i [ngClass]="getOverviewIcon(item.overviewText)"></i>
          </span>
          <span [ngClass]="{'overview-link': item.overviewText.htmlComponent}" (click)="goToItem(item.overviewText.flow, item.overviewText.htmlComponent, section.key, item.decision)">
              {{ item.overviewText.value }}
          </span>
        </ng-container>
      </div>
    </div>
  </ng-container>

</div>
